import SSRIcon from "@ingka/ssr-icon";
import { StyledTooltip } from "../styles/components/integrations.styles";
import closeIcon from '@ingka/ssr-icon/paths/cross';
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "../styles/core/theme";

export const StyledIconButton = styled(SSRIcon)<{ disabled?: boolean }>`
   ${(props) =>
      props.disabled
         ? css`
            color: ${theme.colors.bg.tertiary};
         `
         : css`
            cursor: pointer;
            color: ${theme.colors.text.tertiary};
            
            :hover {
               color: ${theme.colors.text.primary};
            }
         `
   }
   width: 1.2rem;
`;

type IconButtonProps = {
   disabled?: boolean;
   onClick: (event: any) => void;
   icon: any;
   title: string;
};

type toolTipProps = {
   title: string;
   children: any;
   useTooltip: boolean;
};

const WithTooltip = ({ title, children, useTooltip }: toolTipProps) =>
   useTooltip ? <StyledTooltip title={title}>{children}</StyledTooltip> : children;

export const IconButton = ({ disabled = false, onClick, icon, title }: IconButtonProps) => {
   return (
      <WithTooltip title={title} useTooltip={title !== ''}>
         <div>
            <StyledIconButton
               disabled={disabled}
               paths={icon}
               onClick={(event) => {
                  if (!disabled) onClick(event);
               }}
            />
         </div>
      </WithTooltip>
   );
};

export const CloseIconButton = ({
   onClick,
   title = "Close",
   disabled = false
}: {
   onClick: () => void;
   title?: string;
   disabled?: boolean;
}) => {
   return (
      <IconButton
         onClick={onClick}
         icon={closeIcon}
         disabled={disabled}
         title={title}
      />
   );
};
